// Centralised base URL helper
// In production: REACT_APP_API_URL=/api  → base = ''  → images load from /uploads/...
// In development: REACT_APP_API_URL=http://localhost:5000/api → base = http://localhost:5000

export const BASE_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/api$/, '')
  : 'http://localhost:5000';

export const imgUrl = (filename) =>
  filename ? `${BASE_URL}/uploads/products/${filename}` : null;

export const heroImgUrl = (filename) =>
  filename ? `${BASE_URL}/uploads/hero/${filename}` : null;

export const catImgUrl = (filename) =>
  filename ? `${BASE_URL}/uploads/categories/${filename}` : null;
